import React from "react";

function HeighQualityLeads() {
  return <div>HeighQualityLeads</div>;
}

export default HeighQualityLeads;
